import type { CheckedState } from "@radix-ui/react-checkbox";
import { useState } from "react";
import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";

export type CheckboxPopoverProps<T extends Array<string>> = {
	arrayType: T;
	checkedValues: T;
	stateKey: string;
	applyStateKey: string;
	buttonText: string;
	displayText: string;
};

export const CheckboxPopover = <T extends Array<string>>({
	checkedValues,
	buttonText,
	displayText,
	stateKey,
	applyStateKey,
	arrayType,
	onStateChange,
}: CheckboxPopoverProps<T> & Pick<DropdownProps, "onStateChange">) => {
	const [open, setOpen] = useState<boolean>(false);

	return (
		<Popover
			open={open}
			onOpenChange={(open: boolean) => {
				setOpen(open);
				onStateChange({ isPanelOpen: open });
			}}
		>
			<PopoverTrigger asChild>
				<Button
					variant="dropdown"
					className="news-select-trigger text-gold font-bold text-sm p-1 h-full m-2"
				>
					{displayText}
				</Button>
			</PopoverTrigger>
			<PopoverContent className="p-3 w-auto">
				<div className="space-y-2">
					{arrayType.map((option) => (
						<div key={option} className="flex gap-2 items-center">
							<Checkbox
								id={`subchart-${option}`}
								checked={checkedValues.includes(option)}
								onCheckedChange={(checked: CheckedState) => {
									onStateChange({
										[stateKey]: checked
											? [...checkedValues, option]
											: checkedValues.filter((item) => item !== option),
									});
								}}
							/>

							<label
								htmlFor={`subchart-${option}`}
								className="cursor-pointer text-light-gray font-normal"
							>
								{option}
							</label>
						</div>
					))}

					<div className="pt-1 flex justify-center">
						<Button
							variant="dropdown"
							className="font-bold px-4 py-1 h-5"
							onClick={() => {
								onStateChange({
									[applyStateKey]: checkedValues,
									isPanelOpen: false,
								});
								setOpen(false);
							}}
						>
							{buttonText}
						</Button>
					</div>
				</div>
			</PopoverContent>
		</Popover>
	);
};
